import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DeclarerEvenementDto} from '../../accueil/model/declarer-evenement.dto';
import {CodeDesignation, isNotNullOrUndefined} from 'sigale-angular';
import {EvenementDto} from '../dto/evenement.dto';
import {ValiderRefuserJoursTeletravailDto} from '../../validation-teletravail/model/valider-refuser-jours-teletravail.dto';

@Injectable({
	providedIn: 'root'
})
export class EvenementService {

	private url = '/ws/evenements';

	constructor(private http: HttpClient) {
	}

	/**
	 * Récupère les évènements du demandeur renseigné pour la période donnée.
	 * @param logins les logins des demandeurs
	 * @param dateDebut la date de début de la période.
	 * @param dateFin la date de fin de la période.
	 */
	recupererEvenementsPourLoginDemandeurEtPeriode(logins: string[], dateDebut: string, dateFin: string): Observable<EvenementDto[]> {
		const loginsParams = logins.join(',');

		const params = new HttpParams()
			.set('use-case', 'visualisation')
			.set('loginsDemandeurs', loginsParams)
			.set('dateDebut', dateDebut)
			.set('dateFin', dateFin);
		return this.http.get<EvenementDto[]>(`${this.url}`, {params: params});
	}

	/**
	 * Retroune les types possibles pour un évènement.
	 */
	recupererTypesPossibles(): Observable<CodeDesignation[]> {
		return this.http.get<CodeDesignation[]>(`${this.url}/types-possibles`);
	}

	/**
	 * Retroune les durées possibles pour un évènement.
	 */
	recupererDureesPossibles(): Observable<CodeDesignation[]> {
		return this.http.get<CodeDesignation[]>(`${this.url}/durees-possibles`);
	}

	/**
	 * Créée les évènements.
	 * @param declarerEvenementDto le dto permettant de créer les évènements.
	 */
	declarerEvenements(declarerEvenementDto: DeclarerEvenementDto): Observable<void> {
		return this.http.post<void>(this.url, declarerEvenementDto);
	}

	/**
	 * Récupère les évènements des équipiers du responsable pour un période donné, qui peuvent contenir les demandes de télétravail à valider.
	 * @param loginResponsable le login du responsable.
	 * @param dateDebut la date de début de la période.
	 * @param dateFin la date de fin de la période.
	 */
	recupererEvenementsEquipierEtPeriode(loginResponsable: string, dateDebut: string, dateFin: string): Observable<EvenementDto[]> {
		let params = new HttpParams()
			.set('use-case', 'validation')
			.set('loginResponsable', loginResponsable)
			.set('dateDebut', dateDebut);

		if (isNotNullOrUndefined(dateFin)) {
			params = params.set('dateFin', dateFin);
		}

		return this.http.get<EvenementDto[]>(`${this.url}/teletravails`, {params: params});
	}

	/**
	 * Valide ou refuse selon le statut renseigné dans le dto, un ou plusieurs jours de télétravail.
	 * @param validerRefuserJoursTeletravailDto le dto avec les informations pour la validation ou le refus des jours de télétravail.
	 */
	validerRefuserJoursTeletravail(validerRefuserJoursTeletravailDto: ValiderRefuserJoursTeletravailDto): Observable<CodeDesignation> {
		const params = new HttpParams()
			.set('use-case', 'valider-refuser');
		return this.http.put<CodeDesignation>(`${this.url}/teletravails`, validerRefuserJoursTeletravailDto, {params: params});
	}

	/**
	 * Annule l'évènement passé en paramètre.
	 * @param evenementId l'id de l'évènement à annuler.
	 */
	annulerEvenement(evenementId: number): Observable<void> {
		const params = new HttpParams()
			.set('use-case', 'annuler');
		return this.http.delete<void>(`${this.url}/${evenementId}`, {params: params});
	}
}
